import React, { useState, useContext } from 'react'
import { Button, Col, Divider, Row, message, Modal, Table, DatePicker } from 'antd'
import { useHistory } from 'react-router'
import { Context } from '../../../../context'
import SellProductList from './SellProductList'
import PosPayment from '../PosPayment'
import PosSrc from '../../PosSrc'
import DBService from '../../../../utils/DBService'
import ContentModalMain from './ContentModalMain'
import inventorySrc from '../../../inventory/inventorySrc'
import moment from 'moment'

function SellIndex(props) {
  const history = useHistory()
  const [{ auth }, dispatch] = useContext(Context)
  const [productsList, setProductsList] = useState([])
  const [addProducts, setAddProducts] = useState(true)
  const [total, setTotal] = useState(0)
  const [edit, setEdit] = useState(false)
  const [saveSell, setSaveSell] = useState(false)
  const [loading, setLoading] = useState(false)
  const [sellCancelled, setSellCancelled] = useState(false)
  const [itemsWithoutStock, setItemsWithoutStock] = useState([])
  const [recipe, setRecipe] = useState([])
  const [fecha, setFecha] = useState('')

  const getProductsList = data => {
    let amount = 0
    data.map(p => (amount += parseFloat(p.total)))
    setProductsList(data)
  }

  const getTotal = value => {
    let v = Number(value) || 0;
    if (v < 0) v = 0;

    const cents = Math.round(v * 100);
    setTotal(cents / 100);               
  }

  const getRecipe = value => {
    setRecipe(value)
  }

  const cancelSell = () => {
    window.location.reload(false);
  }

  const finishSell = () => {
    setSaveSell(true)
  }

  const onChangeFecha = (date, dateString) => {
    setFecha(dateString)

    // SAT/Digifact rechaza de forma permanente (no reintentable) una
    // certificación cuya fecha de emisión tenga más de 5 días de diferencia
    // con la fecha real de certificación — confirmado contra un error real
    // de Digifact. Avisamos acá, al elegir la fecha, para que no se entere
    // recién cuando la venta ya quedó guardada sin poder certificarse.
    if (dateString && moment().diff(moment(dateString, 'YYYY-MM-DD HH:mm:ss'), 'days') > 5) {
      Modal.warning({
        title: 'Esta venta no se podrá certificar ante SAT',
        content:
          'La fecha elegida tiene más de 5 días de diferencia con la fecha de hoy. SAT no permite certificar una factura electrónica con esa diferencia, así que esta venta se va a guardar igual, pero sin certificar.',
      })
    }
  }

  const showMainModal = async (sellShow) => {
    let getSell = null
    let SkusOptions = null

    try {
      getSell = await PosSrc.getSell(sellShow.id)
      SkusOptions = await inventorySrc.getSkusOptions()
      setLoading(false)
    } catch (err) {
      console.log(err)
      history.go(0)
      return false
    }

    if (getSell.store.company.country.name === 'Honduras') {
      getSell.sell_details.forEach(element => {
        SkusOptions.data.forEach(item => {
          if (element.presentation_id === item.presentation_id) {
            element.presentation_id = item.code
          }
        });
      });
    }

    const content = (
      <ContentModalMain
        sellShow={sellShow}
        getSell={getSell}
        getProductsNotAvailable={getProductsNotAvailable}
        saveSell={saveSell}
        companyCountryName={sellShow?.store.company?.country?.name}
      />
    )

    Modal.info({
      title: '',
      content: content,
      okText: 'Continuar',
      onOk: () => { cancelSell() },
      width: '30%'
    });
  }


  const updateRecipe = async (data, sell_id) => {
    PosSrc.updateRecipe(data, recipe.id, sell_id)
      .then(res => {
        if (res?.data) {
          message.success('Receta actualizada.')
        } else {
          message.error(res.errors.message);
        }
      })
      .catch(e => {
        message.error(e)
      })
  }

  const closeSell = async (obj, save) => {
    if (save) {
      const data = {
        ...obj,
        fecha_nueva: fecha,
      }

      setLoading(true)
      const sells = await DBService.getAll('sells')
      if (sells.length > 0) await saveOfflineSells(sells)
      PosSrc.saveSell(data)
        .then(sellShow => {
          if (sellShow.errors?.message && sellShow.errors?.message[0] === 'Error de conexion') {
            DBService.addOne(data, 'sells').then(sellShow => {
              message.success('Se ha guardado la venta')
              setLoading(false)
              cancelSell()
            })
          }

          if (sellShow?.errors && Object.keys(sellShow.errors)?.length > 0) {
            checkErrors(sellShow)
            setLoading(false)
            return false
          } else {
            if (Object.keys(recipe).length > 0) {
              updateRecipe(data, sellShow.id)
            }
            message.success('Se ha guardado la venta')
            getCash(sellShow)
          }
        })
        .catch(err => {
          console.log(err)
          setLoading(false)
          message.error('Error al guardar la venta')
          return false
        })
    }

    setSaveSell(false)
  }

  const getProductsNotAvailable = () => {
    PosSrc.productsNotAvailable(props.store.id)
      .then(res => {
        res.data.data.length ? showItemsWithLowStock(res.data.data) : history.go(0)
      })
      .catch(err => {
        console.log(err)
        history.go(0)
        return false
      })
  }

  const makeContentTable = (items) => {
    const columns = [
      {
        title: 'Descripción',
        dataIndex: 'description',
        key: 'description',
      },
      {
        title: 'Disponibilidad',
        dataIndex: 'stock',
        key: 'stock',
      }
    ]

    const dataSource = items.map((item, index) => ({
      key: index,
      description: item.description,
      stock: item.stock
    }))

    return <Table dataSource={dataSource} columns={columns} />
  }

  const showErrorItemsWithoutStock = (items) => {
    setItemsWithoutStock(items)

    let message = makeContentTable(items)

    Modal.warning({
      title: 'Productos con Stock Bajo',
      content: message,
      // onOk: () => { onChangeView(true) },
      width: '60%'
    });
  }

  const makeTableItemsWithLowStock = (items) => {
    const columns = [
      {
        title: 'Descripción',
        dataIndex: 'product_description',
        key: 'product_description',
      },
      {
        title: 'Disponibilidad',
        dataIndex: 'quantity',
        key: 'quantity',
      }
    ]

    const dataSource = items.map((item, index) => ({
      key: index,
      product_description: item.product_description,
      quantity: item.quantity
    }))

    return <Table dataSource={dataSource} columns={columns} />
  }

  const showItemsWithLowStock = (items) => {
    let message = makeTableItemsWithLowStock(items)

    Modal.warning({
      title: 'Productos con Stock Bajo',
      content: message,
      // onOk: () => { history.go(0) },
      width: '60%'
    });
  }

  const checkErrors = res => {
    Object.keys(res.errors).map(key => {
      switch (key) {
        case 'phone':
          message.error(res.errors[key][0].replace('phone', 'Teléfono'))
          break
        case 'nit':
          message.error(res.errors[key][0].replace('nit', 'NIT'))
          break
        case 'description':
          message.error(res.errors[key][0].replace('description', 'Descripción'))
          break
        case 'name':
          message.error(res.errors[key][0].replace('name', 'Nombre'))
          break
        case 'email':
          message.error(res.errors[key][0].replace('email', 'Correo Electrónico '))
          break
        case 'items':
          showErrorItemsWithoutStock(res.errors.items[0])
          break
        default:
          message.error(res.errors[key])
          break
      }
      return null
    })
  }

  const getCash = sellShow => {
    PosSrc.getStoreCash(sellShow.store_id).then(response => {
      dispatch({
        type: 'TURN CASH',
        payload: response.data[0],
      })
      showMainModal(sellShow)
    })
  }

  const saveOfflineSells = async data => {
    let _data = {
      store_id: data[0].store_id,
      sells: data.map(d => ({
        seller_id: auth.id,
        store_turn_id: d.store_turn_id,
        payment_method_id: d.payment_method_id,
        description: d.description,
        name: d.name,
        nit: d.nit,
        address: d.address,
        phone: d.phone,
        email: d.email,
        items: d.items,
      })),
    }
    try {
      const response = await PosSrc.saveOfflineSells(_data)

      if (!response?.errors) await DBService.deleteAll('sells')
    } catch (err) {
      console.log(err)
    }
  }

  const onChangeView = status => {
    let validate = true

    productsList.map((dataSrc, i) => {
      if (!validate) return null

      if (productsList.length - 1 > i || productsList.length === 1) {
        if (
          [dataSrc.price, dataSrc.product, dataSrc.units].includes(null) ||
          [dataSrc.price, dataSrc.product, dataSrc.units].includes(undefined) ||
          [dataSrc.price, dataSrc.product, dataSrc.units].includes('')
        ) {
          message.warning(`Todos los campos son obligatorios`)
          validate = false
        } else if (!Number(dataSrc.price) || dataSrc.price.includes('-') || dataSrc.price.includes('+')) {
          message.warning(`El campo Precio unitario debe ser un número mayor o igual a 0`)
          validate = false
        } else if (!Number(dataSrc.units) || dataSrc.units.toString().includes('-') || dataSrc.units.toString().includes('+')) {
          message.warning(`El campo No. Unidades debe ser un número mayor o igual a 0`)
          validate = false
        } else if (dataSrc.total < 0) {
          message.warning('El monto total debe ser mayor o igual a 0')
          validate = false
        } else {
          validate = true
        }
      }
      return true
    })

    if (validate) {
      setAddProducts(status)
      setEdit(status)
    }
  }

  function trunc(x, decimalDigits = 2, returnText = true, longFixed = true) {
    let n = Number(x) || 0;
    const factor = 10 ** decimalDigits;
  
    // redondeo correcto a 2 decimales
    n = Math.round(n * factor) / factor;
  
    if (!returnText) return n;
    return longFixed ? n.toFixed(decimalDigits) : String(n);
  }

  return (
    <>
      <Row gutter={16} className={'sell-row'}>
        <Col xs={24} sm={24} md={24} lg={24}>
          {addProducts && Object.keys(props.quotationData).length === 0 && Object.keys(props.projectData).length === 0 ? (
            <SellProductList
              products={getProductsList}
              productsList={productsList}
              edit={edit}
              store={props.store}
              turn={props.turn}
              isSellCancelled={sellCancelled}
              uncancellSell={_ => setSellCancelled(false)}
              itemsWithoutStock={itemsWithoutStock}
              symbol={props.symbol}
              newTotal={getTotal}
              recipe={getRecipe}
            />
          ) : (
            <PosPayment
              total={total}
              sellUnsaved={_ => setSaveSell(false)}
              saveSell={saveSell}
              productsList={productsList}
              closeSell={closeSell}
              store={props.store}
              turn={props.turn}
              quotationData={props.quotationData}
              projectData={props.projectData}
              symbol={props.symbol}
              companyId={props.companyId}
              country={props.country}
              paymentMethods={props.paymentMethods}
              recipe={recipe}
            />
          )}
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} className={'footer-sell'}>
          <Row gutter={16} justify="space-between" align="middle">
            <Divider className={'divider-custom-margins-users'} />
            <Col xs={4} sm={4} md={4} lg={4}>
              <Button type={'link'} className="cancel-button" onClick={cancelSell}>
                Cancelar venta
              </Button>
            </Col>
            <Col xs={6} sm={6} md={6} lg={6}>
              <DatePicker
                placeHolder={'Seleccionar fecha'}
                size={'medium'}
                format={'YYYY-MM-DD HH:mm:ss'}
                className={'date-picker-custom'}
                value={!fecha ? '' : moment(fecha, 'YYYY-MM-DD HH:mm:ss')}
                onChange={onChangeFecha}
              />
            </Col>
            <Col xs={14} sm={14} md={14} lg={14}>
              {addProducts && Object.keys(props.quotationData).length === 0 && Object.keys(props.projectData).length === 0 ? (
                <>
                  <div className="next-button">
                    <div>
                      TOTAL <span>{props.symbol} {trunc(total)}</span>
                    </div>
                    <Button htmlType="submit" className="title-tendero new-button" onClick={() => onChangeView(false)}>
                      Cobrar
                    </Button>
                  </div>
                </>
              ) : (
                <>
                  <div className="next-button">
                    <Button disabled={Object.keys(props.quotationData).length !== 0} htmlType="submit" className="title-tendero new-button back-button" onClick={() => onChangeView(true)}>
                      &#60; Regresar
                    </Button>
                    <Button loading={loading} htmlType="submit" className="title-tendero new-button" onClick={finishSell}>
                      Finalizar venta
                    </Button>
                  </div>
                </>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}

export default SellIndex
